const container = document.querySelector('.global-operations')
const button = document.querySelector('.country-switcher')
const closeBtn = document.querySelector('.global-operations__close')

var menuOpen = false

function toggleMenu() {
	menuOpen ? closeMenu() : openMenu()
}

function openMenu() {
	menuOpen = true
	animateIn(container)
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

function closeMenu() {
	menuOpen = false
	animateOut(container)
}

if (button) {
	button.addEventListener('click', toggleMenu)
	closeBtn.addEventListener('click', toggleMenu)
}



function animateIn(el) {
	el.classList.add('state')
	setTimeout(() => {
		el.classList.add('open') // display none
	}, 200); // transform - 100px
}

function animateOut(el) {
	el.classList.remove('open') // display none
	setTimeout(() => {
		el.classList.remove('state')
	}, 200); // transform - 100px
}
